import { http } from 'interfaces'
import { type LutValues, type State } from 'services'

export interface Country {
  id: number
  country_desc: string
  country_code: string
  states: State[]
}

export interface CountriesLutValues extends LutValues {
  countries: Country[]
}

export async function countryLutServerCall (): Promise<CountriesLutValues> {
  return await http
    .get('/api/v1/countries/lut/').then(value => value.data)
}

export async function usCountryLutServerCall (): Promise<CountriesLutValues> {
  return await http
    .get('/api/v1/us/countries/lut/').then(value => value.data)
}

export async function allCountriesList (): Promise<Country[]> {
  return await http.get('/api/v1/countries/', {
    params: { page_size: 300 }
  }).then(value => value.data.data)
    .catch(reason => { return { countries: [] } })
}
